














import Component from 'vue-class-component'
import Vue from 'vue'
import FormInput from '@/components/lib/input/FormInput.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import DefaultSelect  from '@/components/lib/select/DefaultSelect.vue'
import SelectStatusFilter from '@/components/select/status/SelectStatusFilter.vue'
import {CompanyEmployeesListFilterModel, StatusType} from '@/services/types'
//import SelectUserRolesMultiple from '@/components/select/userRolesMultiple/SelectUserRolesMultiple.vue'
import {StoreActionTypes} from '@/store/types'

@Component({
    components: {
        FormInput,
        ActionButton,
        DefaultSelect,
        SelectStatusFilter        
        //SelectUserRolesMultiple
    }
})
export default class GridFilter extends Vue{
    private componentClass = 'GridFilter'

    private searchInputValue = ''
    private statusSelectValue = 'null'
    //private roleSelectMultipleValues = []

    mounted() {
        this.searchInputValue = (this.$store.getters.getEmployeesFilterValue as CompanyEmployeesListFilterModel).search
    }

    handleSearchInputChangeEvent(text: string) {
        this.searchInputValue = text
    }

    handleStatusSelectChangeEvent(selected: string) {
        this.statusSelectValue = selected
    }

    // handleRoleSelectChangeEventMultiple(selectedItems: EmployeeRole []) {
    //     this.roleSelectMultipleValues = selectedItems
    // }

    getStatusSelectValue(): StatusType | null {
        if (this.statusSelectValue == 'null') {
            return null
        }
        else {
            return (this.statusSelectValue as StatusType)
        }
    }

     getCompanyEmployeesListFilterModel(): CompanyEmployeesListFilterModel {
        return {
            search: this.searchInputValue,
            status: this.getStatusSelectValue(),
            //roles: this.roleSelectMultipleValues
        }
    }

    getCompanyEmployeesListDefaultFilterModel(): CompanyEmployeesListFilterModel {
        return {
            search: '',
            status: null,
            //roles: []
        }
    }

    okBtnListener() {
        this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_LIST_FILTER, this.getCompanyEmployeesListFilterModel())
    }

    cancelBtnListener() {
        this.searchInputValue = ''
        this.statusSelectValue = 'null'
        //this.roleSelectMultipleValues = []
        this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_LIST_FILTER, this.getCompanyEmployeesListDefaultFilterModel())
    }

    get showSetDefaultFiltersValueBtn(): boolean {
        return this.searchInputValue.length > 0 || this.statusSelectValue != 'null'
    }

    get getOutLineStatus() {
        const filtersValue = (this.$store.getters.getEmployeesFilterValue as CompanyEmployeesListFilterModel);
        return filtersValue.search.length == 0 && filtersValue.status == null ? true : false
    }
}
